import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-base font-medium" }
const _hoisted_2 = { class: "-mt-1" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs mr-2 text-red-500"
}
const _hoisted_4 = {
  key: 1,
  class: "text-xs mr-2 text-gray-400"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Проголосовать ")
const _hoisted_6 = { class: "mt-4" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-green-500"
}
const _hoisted_8 = { class: "text-xs text-gray-400" }
const _hoisted_9 = {
  key: 1,
  class: "text-xs text-gray-400"
}

import { ref, computed, PropType } from "vue";

import { formatDate } from "@/utils";

import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";

import NewsPostVotingVariant from "./NewsPostVotingVariant.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsPostVoting',
  props: {
  // eslint-disable-next-line no-undef
  voting: { type: Object as PropType<PostVoting>, required: true },
},
  emits: ["vote"],
  setup(__props, { emit }) {

const props = __props




const maxVotingValue = computed(() =>
  Math.max.apply(
    null,
    props.voting.variants.map((variant) => variant.count)
  )
);

const endDate = computed(() =>
  formatDate(props.voting.endDate, {
    dateStyle: "long",
    timeStyle: "short",
  })
);

const selectedVariants = ref<number[]>([]);

function toggleVariant(variantId: number) {
  if (props.voting.multiple) {
    if (isSelectedVariant(variantId)) {
      selectedVariants.value = selectedVariants.value.filter(
        (variant) => variant !== variantId
      );
    } else {
      selectedVariants.value.push(variantId);
    }
  } else {
    if (isSelectedVariant(variantId)) {
      selectedVariants.value = [];
    } else {
      selectedVariants.value = [variantId];
    }
  }
}

function isSelectedVariant(variantId: number) {
  return selectedVariants.value.includes(variantId);
}

function handleVote() {
  if (selectedVariants.value.length) {
    emit("vote", [...selectedVariants.value]);
    selectedVariants.value = [];
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.voting.title), 1),
    _createElementVNode("div", _hoisted_2, [
      (!__props.voting.view)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " Анонимное "))
        : _createCommentVNode("", true),
      (__props.voting.multiple)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Множественный выбор "))
        : _createCommentVNode("", true)
    ]),
    (__props.voting.variants?.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["mt-2", { 'pointer-events-none': __props.voting.voted }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.voting.variants, (variant) => {
            return (_openBlock(), _createBlock(NewsPostVotingVariant, {
              onClick: ($event: any) => (toggleVariant(variant.id)),
              key: variant.id,
              selected: isSelectedVariant(variant.id),
              variant: variant,
              voted: __props.voting.voted,
              "show-result": __props.voting.view,
              "max-value": _unref(maxVotingValue)
            }, null, 8, ["onClick", "selected", "variant", "voted", "show-result", "max-value"]))
          }), 128))
        ], 2))
      : _createCommentVNode("", true),
    (selectedVariants.value.length)
      ? (_openBlock(), _createBlock(UiBtn, {
          key: 1,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleVote())),
          stretched: "",
          class: "mt-4"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (__props.voting.voted)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " Вы уже проголосовали! "))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_8, "Дата окончания: " + _toDisplayString(_unref(endDate)), 1),
      (__props.voting.view)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Проголосовало: " + _toDisplayString(__props.voting.votes || 0) + " чел. ", 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})